import React, {Component} from 'react'
import axios from 'axios'
import Modal from "react-bootstrap/Modal";
import FileUpload from '../../commons/components/FileUpload'

import AS from '../Login/Service/Authentication'
import MS from '../../commons/services/Moment'
import CS from '../../commons/services/Common'
import { ROUTES } from '../../commons/constants/routes/routes';

class Main extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isShow: false,
            item: {},
            items: [],
            totalCount: 0,
            pageSize: 0,
            info: {}
        }
        this.fileInfos = {};

        this.getItem = this.getItem.bind(this);
        this.getItems = this.getItems.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.getItem();
        this.getItems(1);
    }

    async getItem() {
        let res = await axios.get(`/cst/api/myinfo`);
        if(typeof res != 'undefined') {
            this.setState({
                info: {
                    id: res.data.account.id,
                    constructorName: res.data.constructor.constructorName,
                    email: res.data.account.email,
                    phone: res.data.account.phone,
                    today: MS.format(new Date(), 'YYYY.MM.DD')
                }
            })
        }
    }

    async getItems(pageIndex) {
        try {
            let params = {
                isPaging: true,
                start: (pageIndex-1) * 10,
                length: 10,
                userId: AS.getLoggedInId()
            }
            await axios.get("/cst/api/inquiry", { params
            }).then(res => {
                this.setState({
                    items: res.data.data,
                    totalCount: res.data.recordsTotal,
                    pageSize: Math.ceil(res.data.recordsTotal / 10)
                });
            }).catch(error => {
                console.log(error);
            });
        } catch(e) {
            console.error(e);
        }
    }

    controlModal = (isShow, item) => {
        this.setState({
            isShow: isShow,
            item: item
        });
    }

    doSetFile = (category, fileInfos) => {
        this.fileInfos[category] = fileInfos;
    }

    async handleSubmit(e) {
        e.preventDefault();
        const data = new FormData(e.target);
        let item = {
            userId: data.get('constructorId'),
            title: data.get('title'),
            content: data.get('content'),
            fileInfos: this.fileInfos.file
        }

        let result = await CS.create('/cst/api/inquiry', item);
        if(result.isSuccess)
            window.location.href = ROUTES.INQUIRY;        
    }


    render() {
        const { isShow, item, items, info} = this.state;
        
        return (
            <>
                <div className="page-tit gray">
                    <div className="container">
                        <h2 className="tit">문의하기</h2>
                    </div>
                </div>

                <div className="container">
                    <div className="card2 mt-40 px-50 py-30">
                        <form onSubmit={this.handleSubmit}>
                            <input type="hidden" name="constructorId" defaultValue={info.id} />
                            <table className="form-table">
                                <colgroup>
                                <col style={{width: "12%"}}/>
                                    <col />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>시공사 명</th>
                                        <td>
                                            <div className="f-stack">
                                                <div>
                                                    <strong className="mr-10">{info.constructorName}</strong>
                                                    <span>{info.email}</span>
                                                    <span className="mx-10">/</span>
                                                    <span>{info.phone}</span>
                                                </div>
                                                <div className="size13">{info.today}</div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>문의제목</th>
                                        <td>
                                            <input type="text" className="wp100" name="title" placeholder="제목입력" required />
                                        </td>
                                    </tr>
                                    <tr>
                                        <th className="top pt-20">문의내용</th>
                                        <td>
                                            <textarea rows="6" className="wp100" name="content" placeholder="내용입력" required></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>파일업로드</th>
                                        <td>
                                            <FileUpload className="w520" handleUploadFile={this.doSetFile} category="file" accept="image/*" />
                                            <span className="unit ml-10 size14">jpg, png 파일</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="btn-areaC2 mb-0">
                                <button type="submit" className="btn primary">보내기</button>
                            </div>
                        </form>
                    </div>

                    <h3 className="content-tit2">문의 내역</h3>
                    <div className="card2 inq-list">
                        <table className="basic gray size14">
                            <colgroup>
                                <col style={{width: "13%"}}/>
                                <col />
                                <col style={{width: "10%"}}/>
                                <col style={{width: "7%"}}/>
                                <col style={{width: "12%"}}/>
                            </colgroup>
                            <tbody>
                                {
                                    items.length > 0
                                        ?
                                        items.map((row, index) => (
                                            <tr key={row.id}>
                                                <td>{row.inquiryDt}</td>
                                                <td className="left pl-20">{row.title}</td>
                                                <td>파일유무</td>
                                                <td><strong>{row.fileId == null ? '무' : '유'}</strong></td>
                                                <td>
                                                    <button type="button" className="btn sm" onClick={() => this.controlModal(true, row)}>
                                                        {row.answer == null ? '확인중' : '답변완료'}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                        :
                                        <tr>
                                            <td colSpan="5">문의하신 내역이 존재하지 않습니다.</td>
                                        </tr>
                                }
                                <Answer show={isShow} item={item} handler={this.controlModal} />
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        )
    }
}



class Answer extends React.Component {
    render() {
        const {show, item} = this.props;
        const content = CS.lineAlignment(item.content);
        const answer = CS.lineAlignment(item.answer);
        return (
            <>
            <Modal show={show} size="lg">
                <Modal.Body>
                    <div className="bg-gray que">
                        <table className="form-table">
                            <colgroup>
                                <col style={{width: "12%"}}/>
                                <col />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>문의제목</th>
                                    <td>
                                        <div className="f-stack">
                                            <div>{item.title}</div>
                                            <div className="size13">{item.inquiryDt}</div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th className="top">문의내용</th>
                                    <td dangerouslySetInnerHTML={{ __html: content }}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="ans mt-20">
                        <div className="text-right size13 mb-5">
                            <span className="mr-10">응답 시간</span>
                            <span>{item.answerDt == null ? '확인중' : answer}</span>
                        </div>
                        <table className="form-table">
                            <colgroup>
                                <col style={{width: "12%"}}/>
                                <col />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className="top">답변내용</th>
                                    <td dangerouslySetInnerHTML={{ __html: item.answer }}></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="foot-btn">
                        <button type="button" className="btn primary" onClick={() => this.props.handler(false, '')}>확인</button>
                    </div>
                </Modal.Footer>
            </Modal>
            
            </>
        );
    }
}

export default Main
